import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enUS from './locales/en-US';
import enGB from './locales/en-GB';
import nl from './locales/nl';
import es from './locales/es';
import fr from './locales/fr';
import de from './locales/de';
import it from './locales/it';
import tr from './locales/tr';
import zhCN from './locales/zh-CN';
import { DEVICE_LANGUAGE_KEY, defaultPreferences, deviceLanguage } from '../contexts/userPreferences';
import { formatMinutes } from '../utils/duration';

const resources = {
  'en-US': enUS,
  'en-GB': enGB,
  'nl-NL': nl,
  'es-ES': es,
  'fr-FR': fr,
  'de-DE': de,
  'it-IT': it,
  tr,
  'zh-CN': zhCN,
};

const deviceStorage = () => {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next);

if (!i18n.isInitialized) {
  i18n.init({
    resources,
    fallbackLng: 'en-US',
    // `lng` decides the start, so the detector never detects: it only writes
    // each language shown back to the device for the next start.
    lng: deviceLanguage(deviceStorage(), Object.keys(resources)) ?? defaultPreferences.language,
    debug: IS_LOCALHOST,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: DEVICE_LANGUAGE_KEY,
    },
  });
  i18n.services.formatter?.add('minutes', (value, lng) => formatMinutes(Number(value), lng));
}

// Locale files are statically bundled into i18next at init time.
// When a locale file changes, accept the HMR update here and immediately
// trigger a full page reload so i18next re-initialises from scratch.
// Using accept() rather than decline() ensures the reload fires automatically
// instead of being blocked by a React Fast Refresh boundary higher in the graph.
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    window.location.reload();
  });
}

export default i18n;
